import { cn } from '@/platform/lib/utils';

const TabNavItem = ({
    as: Component = 'button',
    active = false,
    // eslint-disable-next-line no-unused-vars -- plain-text label, read by TabNav for the mobile <select>
    label,
    className,
    children,
    ...props
}) => (
    <Component
        {...(Component === 'button' && { type: 'button' })}
        aria-current={active ? 'page' : undefined}
        className={cn(
            'focus-visible:outline-primary-600 border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap transition-colors focus-visible:outline-2 focus-visible:outline-offset-2',
            active
                ? 'border-primary-600 text-primary-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
            className
        )}
        {...props}
    >
        {children}
    </Component>
);

export default TabNavItem;
